// components/widgets/Stakeholders/StakeholderWidgetContainer.jsx
import React from "react";
import WidgetContainer from "../WidgetContainer.jsx";
import pandaImg from "../../../../../assets/panda_stakeholders.png";
import StakeholderBuilder from "./StakeholderBuilder.jsx";
import StakeholderListCelebration from "../../Celebration/StakeholderListCelebration.jsx";
import JourneyShowcase from "./JourneyShowcase.jsx";

const StakeholderListContainer = ({
  userId,
  subsectionId,
  onComplete,
  onPhaseChange,
}) => {
  return (
    <WidgetContainer
      userId={userId}
      subsectionId={subsectionId}
      onComplete={onComplete}
      onPhaseChange={onPhaseChange}
      intro={{
        image: pandaImg,
        title: "Listing Stakeholders",
        description:
          "Let’s map the key people who influence your work and growth. A stakeholder map helps you see who supports your goals, who you need to engage with, and where stronger connections can help you move forward.",
        buttonLabel: "Let's Get Started",
      }}
      steps={[
        {
          id: "builder",
          title: "List your stakeholders",
          component: StakeholderBuilder,
        },
        {
          id: "celebration",
          title: "Stakeholder Summary",
          component: StakeholderListCelebration,
          fullScreen: true, 
        },
        {
          id: "showcase",
          title: "Stakeholder Summary",
          component: JourneyShowcase,
          fullScreen: true,
        },        
      ]}
    />
  );
};

export default StakeholderListContainer;
